<template>
    <div class="modal fade" role="dialog" id="ModalTransferir">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Transferir Interacción</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div v-if="cargando_agentes">
                            <div class="col-md-12 text-center">
                                <h4><i class="fal fa-spinner fa-spin"></i> Procesando la información...</h4>
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="agentesDisponibles.length === 0">
                                <div class="col-md-12 text-center">
                                    <h4><i class="fal fa-warning "></i> No existen agentes disponibles</h4>
                                </div>
                            </div>
                            <div v-else>
                                <div class="form-group">
                                    <label>Por favor, seleccione un agente para transferir la interacción.</label>
                                    <select name="agenteSeleccionado" class="form-control" style="width:100%;"
                                            v-model="agenteSeleccionado">
                                        <option :value="null">Seleccione un agente</option>
                                        <option v-for="agente in agentesDisponibles" :value="agente.id"
                                                :key="agente.id">
                                            {{agente.nombre_completo}}
                                        </option>
                                    </select>
                                </div>
                                <div class="modal-footer">
                                    <button class="btn btn-success center-block" @click.prevent="transferir"> Transferir</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex'

    export default {
        data: function () {
            return {
                agenteSeleccionado: null,

                id_inter_global: null,
                cargando_agentes: true,
                motivo_error: '',
                loading_transferir: false,
            }
        },
        computed: {
            ...mapGetters({
                agentesDisponibles: 'agentes/agentesDisponibles'
            }),
        },
        name: "TransferirModalComponent",
        methods: {
            show(data){
                this.reset()
                this.id_inter_global = data
                $('#ModalTransferir').modal('show')
                this.buscarAgentes()

            },
            hide(){
                $('#ModalTransferir').modal('hide')
            },
            reset(){
                this.cargando_agentes = false
                this.agenteSeleccionado = null
                this.loading_transferir = false

            },
            showAlert(data){
                this.$swal(data.message);
            },
            buscarAgentes() {
                this.cargando_agentes = true
                this.$store.dispatch('agentes/buscarAgentes',{
                    id_inter_global: this.id_inter_global
                })
                    .then(response => {
                        this.cargando_agentes = false
                    }).catch(error => {
                    this.cargando_agentes = false
                })
            },
            transferir() {
                this.motivo_error = ''
                this.loading_transferir = true
                if (this.agenteSeleccionado === null) {
                    this.motivo_error = 'Seleccione un agente.'
                    this.loading_transferir = false
                } else {
                    this.$store.dispatch('interacciones/transferir', {
                        id_agente: this.agenteSeleccionado,
                        id_inter_global: this.id_inter_global
                    }).then(response => {
                        this.reset()
                        this.hide()
                        console.log('data')
                        console.log(response)
                        this.showAlert(response)
                    }).catch(error => {
                        this.showAlert(error)
                        this.reset()
                        this.hide()
                    })
                }
            }
        },
    }
</script>